module.exports = __webpack_public_path__ + "img/PTTSymmetryClara01.ce10c966.jpg";